const TEN = 10;

function getMonth(date: Date) {
  const month = date.getMonth() + 1;

  return month < TEN ? `0${month}` : month;
}

function getDate(date: Date) {
  const day = date.getDate();

  return day < TEN ? `0${day}` : day;
}

function getHours(date: Date) {
  const hour = date.getHours();

  return hour < TEN ? `0${hour}` : hour;
}

function getMinutes(date: Date) {
  const minutes = date.getMinutes();

  return minutes < TEN ? `0${minutes}` : minutes;
}

export function getTimestamp(timestamp?: string | number) {
  if (!timestamp) return "";

  const date = new Date(timestamp);

  return `${date.getFullYear()}-${getMonth(date)}-${getDate(date)} ${getHours(date)}:${getMinutes(date)}`;
}
